import type { PaginatedQuery } from "@shared/types/list";
import { DEFAULT_PAGE_SIZE } from "@shared/types/list";
import { t } from "@shared/utils/i18n";

/** 添加弹窗：服务商下拉 + 渠道代码模糊搜索 */
export interface AddProviderChannelQueryParam extends PaginatedQuery {
    /** 当前 VC 物流渠道 ID（提交映射用） */
    channelId: string;
    /** 服务商，空=全部（请求字段 providerCode） */
    providerId: string;
    /** 渠道代码：仅模糊 */
    channelCode: string;
}

export const DEFAULT_ADD_PROVIDER_CHANNEL_QUERY: Omit<AddProviderChannelQueryParam, "channelId"> = {
    providerId: "",
    channelCode: "",
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
};

export const ADD_PROVIDER_CHANNEL_SEARCH_OPTIONS = [{ label: t("渠道代码"), value: "channelCode", exact: false }];

export const ADD_PROVIDER_CHANNEL_TIP = t("请与客户确认服务商的渠道代码，如查询不到，请让客户先同步并开启物流渠道！");

/**
 * POST /manage/warehouseVcLogisticsChannel/mapping/candidateList → data.items[]
 */
export interface AddProviderChannelCandidateItemApi {
    providerChannelId?: number;
    providerCode?: string;
    providerName?: string;
    channelCode?: string;
    channelName?: string;
}

/** 可添加的服务商物流渠道候选行 */
export interface AddProviderChannelCandidateRow {
    id: number;
    channelName: string;
    channelCode: string;
    providerId: string;
    providerName: string;
}

export function mapAddProviderChannelCandidateItem(item: AddProviderChannelCandidateItemApi): AddProviderChannelCandidateRow {
    const providerChannelId = Number(item.providerChannelId) || 0;
    return {
        id: providerChannelId,
        channelName: item.channelName || "",
        channelCode: item.channelCode || "",
        providerId: item.providerCode || "",
        providerName: item.providerName || "",
    };
}

export function getAddProviderChannelRowActions() {
    return [{ label: t("添加"), key: t("添加") }];
}
